/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const analyticsModule = require('@utils/analytics/analyticsModule');
const categoriesModule = require('@utils/categories/categoriesModule');
const cmsModule = require('@utils/cms/cmsModule');
const commonModule = require('@utils/common/commonModule');
const filtersModule = require('@utils/filters/filtersModule');
const HistogramService = require('./histogramService');
const histogramDirective = require('./histogramDirective');
const histogramIconDirective = require('./histogramIconDirective');

const histogramModule = angular
    .module('enervee_utils.histogram', [
        analyticsModule.name,
        categoriesModule.name,
        cmsModule.name,
        commonModule.name,
        filtersModule.name,
    ])
    .factory('HistogramService', HistogramService)
    .directive('histogram', histogramDirective)
    .directive('histogramIcon', histogramIconDirective);

module.exports = histogramModule;
